import React, { useState, useEffect } from 'react';
import ReportModal from '../../../../common/src/legacy/ReportModal';
import { LouiseQuote, ProductWithQuality } from '../../../../../types/Quotes';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import useTracking from '../../../../common/src/hooks/tracking/useTracking';

interface Props {
  offer: LouiseQuote | ProductWithQuality;
  showReportModal: boolean;
  setShowReportModal: (arg0: boolean) => void;
}

const isProduct = (
  offer: LouiseQuote | ProductWithQuality,
): offer is ProductWithQuality => !!(offer as ProductWithQuality).hash_id;

const OfferReportModal: React.FC<React.PropsWithChildren<Props>> = ({
  offer,
  showReportModal,
  setShowReportModal,
}) => {
  const { distribution, user } = useAuth();
  const { trackEvent } = useTracking();

  const [clickTime, setClickTime] = useState(Date.now());

  useEffect(() => {
    if (showReportModal) {
      setClickTime(Date.now());
      trackEvent('Report Quote Problem in Sales Conversation');
    }
  }, [showReportModal]);

  return (
    <ReportModal
      showModal={showReportModal}
      setShowModal={setShowReportModal}
      quoteId={isProduct(offer) ? offer.hash_id : offer.id}
      batchId="NONE"
      insuranceCompany={
        offer.info.company.name?.toUpperCase() ||
        offer.info.company.key.toUpperCase()
      }
      insuranceType={offer.info.insurance_type.toUpperCase()}
      brokerDistribution={distribution}
      clickTime={clickTime}
      flow="Louise Offer Generation"
      rawResponse={offer.info}
      me={user}
    />
  );
};

export default OfferReportModal;
